//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from '../../../services/clipboard.service';

@Component({
    selector: 'app-alert-clipboard-copy',
    templateUrl: './alert-clipboard-copy.component.html',
    styleUrls: ['./alert-clipboard-copy.component.scss'],
    standalone: false
})
export class AlertClipboardCopyComponent {
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: IAlertClipboardDialogData,
      private readonly clipboard: ClipboardService,
      private translate: TranslateService) {

    this.translate.get(['ALERT_OK', 'CANCEL_CAP']).subscribe(vals => {
        data.rejectBtnName = data.rejectBtnName ? data.rejectBtnName : vals['CANCEL_CAP'];
        data.acceptBtnName = data.acceptBtnName ? data.acceptBtnName : vals['ALERT_OK'];
    });
  }

  onClick() {
    this.clipboard.copyMessage(this.data.clipboardContent, this.translate.instant('COPIED_TO_CLIPBOARD')).then(null);
  }

}

export interface IAlertClipboardDialogData {
  title: string;
  titleRight: string;
  preContent: string;
  clipboardContent: string;
  postContent: string;
  copyButtonId: string;
  clickText: string;

  acceptBtnName: string;
  rejectBtnName: string;
  showRejectBtn: boolean;
}
